// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  getRolesPending: false,
  getRolesError: null,
  roleList: [],
  rolesPagination: {
    total: 0,
    page: 1,
    pages: 1,
    nextPage: null,
    prevPage: null
  },
  getFunctionsModulesPending: false,
  getFunctionsModulesError: null,
  createRolePending: false,
  createRoleError: null,
  getRoleByIdPending: false,
  getRoleByIdError: null,
  updateRolePending: false,
  updateRoleError: null,
  deleteRolePending: false,
  deleteRoleError: null,
  roleIdCloned: '',
  getToolsByRolePending: false,
  getToolsByRoleError: null
};

export default initialState;
